import { AxiosResponse } from 'axios';
import { API } from '../../utils/axios';
import {
  APIResponseStatus,
  StartPaymentIntentResponse,
  VisitBookingResponse,
  VisitInsertUpdateParams,
} from '../types';
import { ServiceTypes } from '../../features/get-care/Components/select-service-type/types';
import { getVisitingBookingParamsFromVisitUpdateParam } from '../utils/getVisitingBookingParamsFromVisitUpdateParam';

class GetCareServices {
  static insertUpdateVisit(params: VisitInsertUpdateParams) {
    const visitBookingParams = getVisitingBookingParamsFromVisitUpdateParam(params);
    return API.post<any, AxiosResponse<VisitBookingResponse>>(
      `/v1/resources/Visit/update-status/${params.visitStatus}`,
      visitBookingParams,
    ).then((res) => res.data);
  }

  static getServiceTypes(params: {
    state: string;
    total: boolean;
    offset: number;
    limit: number;
    active: boolean;
  }) {
    return API.post<any, AxiosResponse<APIResponseStatus<ServiceTypes>>>(
      `/v1/resources/ServiceType/_search`,
      params,
    ).then((res) => res.data);
  }

  static startPaymentIntent = async (params: {
    totalAmount: number;
    payableAmount: number;
    patientId: string;
    visitId: any;
    description: string;
    paymentMethodID: string;
    serviceTypeId: string;
  }) => {
    return API.post<any, AxiosResponse<APIResponseStatus<StartPaymentIntentResponse | undefined>>>(
      `/v1/resources/Payment/PaymentIntent/${params.paymentMethodID}`,
      params,
    ).then((res) => res.data);
  };
}

export default GetCareServices;
